export const One = '0';